'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import type { SliderProps as RadixSliderProps } from '@radix-ui/react-slider';
import * as RadixSlider from '@radix-ui/react-slider';
interface SliderProps extends RadixSliderProps {
  min: number;
  max: number;
  value: number[];
  /** @deprecated 값 위치 그라데이션 폭 — 표준 트랙으로 전환되어 더 이상 사용하지 않음 */
  range?: number;
  className?: string;
}
export const Slider = t0 => {
  const $ = _c(16);
  let className;
  let max;
  let min;
  let props;
  let value;
  if ($[0] !== t0) {
    const {
      className: t1,
      value: t2,
      min: t3,
      max: t4,
      range,
      ...t5
    } = t0;
    className = t1;
    value = t2;
    min = t3;
    max = t4;
    props = t5;
    $[0] = t0;
    $[1] = className;
    $[2] = max;
    $[3] = min;
    $[4] = props;
    $[5] = value;
  } else {
    className = $[1];
    max = $[2];
    min = $[3];
    props = $[4];
    value = $[5];
  }
  let t1;
  if ($[6] !== className) {
    t1 = cn("relative flex h-6 touch-none select-none items-center", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <RadixSlider.Track className="relative h-6 grow cursor-pointer overflow-hidden rounded-pill bg-Gray-200"><RadixSlider.Range className="absolute h-full rounded-pill bg-B-400" /></RadixSlider.Track>;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <RadixSlider.Thumb className={cn("block size-24 rounded-pill border-4 border-B-300 bg-Gray-white", "cursor-pointer transition-colors duration-200 ease-in-out", "hover:border-B-500", "focus-visible:border-B-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500")} />;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== max || $[11] !== min || $[12] !== props || $[13] !== t1 || $[14] !== value) {
    t4 = <RadixSlider.Root max={max} min={min} value={value} {...props} className={t1}>{t2}{t3}</RadixSlider.Root>;
    $[10] = max;
    $[11] = min;
    $[12] = props;
    $[13] = t1;
    $[14] = value;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};